import { PathTemplate } from 'utils/PathTemplate';

// Not exhaustive; there are more addressable documents than this, these
// are just enough to map routes to Firestore paths. Note that the
// placeholder names are the same as in the routes.
//
// Ideally we wouldn't be slinging raw database paths around, but that
// would be a bigger refactor and a separate conversation.

export const client = new PathTemplate('clients/:clientID');
export const project = new PathTemplate(
    'clients/:clientID/projects/:projectID'
);
export const creative = new PathTemplate(
    'clients/:clientID/projects/:projectID/creatives/:creativeID'
);
export const ad = new PathTemplate(
    'clients/:clientID/projects/:projectID/creatives/:creativeID/ads/:adID'
);
export const tearsheet = new PathTemplate(
    'clients/:clientID/projects/:projectID/creatives/:creativeID/tearsheets/:tearsheetID'
);
export const tearsheetAd = new PathTemplate(
    'clients/:clientID/projects/:projectID/creatives/:creativeID/tearsheets/:tearsheetID/ads/:adIndex'
);

const documentFolders = [creative, project, client];
const any = [tearsheetAd, tearsheet, ad, ...documentFolders];

function requireMatchFirst(
    pts: ReadonlyArray<PathTemplate>,
    path: string
): Record<string, string> {
    for (const pt of pts) {
        const vars = pt.match(path);
        if (vars) return vars;
    }
    const qPath = JSON.stringify(path);
    const qcTemplates = pts.map((pt) => JSON.stringify(pt.template)).join(', ');
    throw new Error(
        `DatabasePaths: ${qPath} did not match any of templates ${qcTemplates}`
    );
}

export function requireMatchDocumentFolder(
    dbPath: string
): Record<string, string> {
    return requireMatchFirst(documentFolders, dbPath);
}

export function requireMatchAnyDocument(
    dbPath: string
): Record<string, string> {
    return requireMatchFirst(any, dbPath);
}
